module.exports = __webpack_public_path__ + "img/71_1.8cf546c4.png";